module.exports = __webpack_public_path__ + "static/media/icn_mainnav_info_light.8d2e5265.svg";